"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as t } from "react";
import l from "../components/Icon/SvgIcon.js";
const m = (e) => /* @__PURE__ */ o(
  l,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.25 12.009h17.5v-2.75H3.25zm17.5 3.356a2.377 2.377 0 0 1-2.375 2.375H5.625a2.377 2.377 0 0 1-2.375-2.375v-2.106h17.5zM5.625 6.25h12.75a2.37 2.37 0 0 1 2.283 1.759H3.342A2.37 2.37 0 0 1 5.625 6.25M18.375 5H5.625A3.63 3.63 0 0 0 2 8.625v6.74a3.63 3.63 0 0 0 3.625 3.625h12.75A3.63 3.63 0 0 0 22 15.365v-6.74A3.63 3.63 0 0 0 18.375 5",
        clipRule: "evenodd"
      }
    )
  }
), a = t(m);
export {
  a as PaymentMethods,
  a as default
};
